import React from 'react';
import { Header } from '../components/Layout/Header';
import { Footer } from '../components/Layout/Footer';

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-base-200">
      <Header />

      {/* Content */}
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-base-100 rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold mb-6">Terms of Use</h1>
          <p className="text-sm text-base-content/70 mb-8">Last updated: July 23, 2025</p>

          <div className="prose prose-lg max-w-none">
            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">1. Acceptance of Terms</h2>
            <p className="text-base-content/80 leading-relaxed mb-6">
              By accessing and using SuprHR, you accept and agree to be bound by the terms and provision of this agreement.
              If you do not agree to abide by the above, please do not use this service.
            </p>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">2. Service Description</h2>
            <p className="text-base-content/80 leading-relaxed mb-6">
              SuprHR is a simple resume screening platform that uses AI to analyze resumes against job descriptions.
              We provide <strong className="text-primary">ONLY screening services</strong> - no ATS, no SSO, no complex onboarding, no nonsense.
            </p>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">3. User Responsibilities</h2>
            <ul className="list-disc list-inside space-y-2 text-base-content/80 mb-6 ml-4">
              <li>You are responsible for maintaining the confidentiality of your account</li>
              <li>You agree to provide accurate and complete information</li>
              <li>You will not upload malicious files or content that violates any laws</li>
              <li>You are responsible for ensuring you have rights to upload and process resumes</li>
            </ul>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">4. Privacy and Data</h2>
            <p className="text-base-content/80 leading-relaxed mb-6">
              We take your privacy seriously. All data is processed securely and in accordance with our Privacy Policy.
              Resume content is used solely for AI analysis and is not shared with third parties.
            </p>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">5. Payment Terms</h2>
            <ul className="list-disc list-inside space-y-2 text-base-content/80 mb-6 ml-4">
              <li>Credits are purchased through Stripe and are non-refundable</li>
              <li>Each resume screening costs 1 credit</li>
              <li>Credits do not expire and remain in your account until used</li>
              <li>All payments are final as per our no-refund policy</li>
            </ul>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">6. Service Limitations</h2>
            <p className="text-base-content/80 leading-relaxed mb-6">
              SuprHR is provided "as is" without warranties. We do not guarantee 100% accuracy of AI analysis.
              Results should be used as screening tools, not as sole hiring decisions.
            </p>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">7. Termination</h2>
            <p className="text-base-content/80 leading-relaxed mb-6">
              We reserve the right to terminate accounts for violations of these terms.
              You may cancel your account at any time, but unused credits are non-refundable.
            </p>

            <h2 className="text-xl font-bold text-primary mb-4 border-b border-base-300 pb-2">8. Changes to Terms</h2>
            <p className="text-base-content/80 leading-relaxed mb-6">
              We may update these terms from time to time. Continued use of the service constitutes acceptance of updated terms.
            </p>

            <div className="alert alert-info mt-8">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current shrink-0 w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <span>Questions about these terms? <a href="/contact" className="link link-hover">Contact us</a> for clarification.</span>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage; 